<template>
  <div v-if="showExecutiveView">
    For Devs Only - Insert New Components here
  </div>
  <div v-else>
    {{ underConstructionText }}
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      underConstructionText: 'Executive View Coming Soon',
    };
  },
  computed: {
    ...mapState({
      featureFlags: state => state.main.featureFlags,
    }),
    showExecutiveView() {
      return this.featureFlags.find(flag => flag.name === 'release-executive-view');
    },
  },
};
</script>
